import { RequestData } from '@ant-design/pro-components';

import { request } from '@umijs/max';

import {
  FindChartsRequest,
  FindChartsResponse,
  FindDashboardSamplesRequest,
  FindDashboardSamplesResponse,
  FindDefectSetRequest,
  FindDefectSetResponse,
  FindImageAnglesRequest,
  FindImageAnglesResponse,
  FindImagesRequest,
  FindImagesResponse,
  FindSamplesRequest,
  FindSamplesResponse,
  FindTimesRequest,
} from '@/types';

export async function findDefectSets(payload: FindDefectSetRequest): Promise<FindDefectSetResponse[]> {
  return request('samples/findDefectSets', {
    data: payload,
    method: 'POST',
  });
}

export async function findSamples(payload: null | Partial<FindSamplesRequest>): Promise<FindSamplesResponse[]> {
  if (!payload) {
    return [];
  }

  return request('/samples/find', {
    data: payload,
    method: 'POST',
  });
}

export async function findDashboardSamples(payload: null | Partial<FindDashboardSamplesRequest>): Promise<FindDashboardSamplesResponse[]> {
  if (!payload) {
    return [];
  }

  return request('/samples/findSamples', {
    data: payload,
    method: 'POST',
  });
}

export async function findImages(payload: null | Partial<FindImagesRequest>): Promise<RequestData<FindImagesResponse>> {
  if (!payload) {
    return {
      data: [],
      success: true,
      total: 0,
    };
  }

  return request('samples/findImages', {
    data: payload,
    method: 'POST',
  });
}

export async function findCharts(payload: null | Partial<FindChartsRequest>): Promise<FindChartsResponse[]> {
  if (!payload) {
    return [];
  }

  return request('samples/findCharts', {
    data: payload,
    method: 'POST',
  });
}

export async function findTimes(payload: null | Partial<FindTimesRequest>): Promise<FindChartsResponse[]> {
  if (!payload) {
    return [];
  }

  return request('samples/findTimes', {
    data: payload,
    method: 'POST',
  });
}

export async function findImageAngles(payload: null | Partial<FindImageAnglesRequest>): Promise<FindImageAnglesResponse[]> {
  if (!payload) {
    return [];
  }

  return request('samples/findImageAngles', {
    data: payload,
    method: 'POST',
  });
}
